module.exports = __webpack_public_path__ + "static/homepage_banner-1de70acb23a54f0eb570aededf902f82.jpg";